import { useSelector } from 'react-redux';
import CEUIExitButton from 'ContentEditorUI/components/header/ExitButton';
import PersonalizationExitWrapper from 'personalization-lib/components/navigation/ContentEditorExitWrapper';
import { getContentModelPersonalizationStrategyId } from '../redux/selectors/pageContentModelSelectors';
// @ts-expect-error not typed yet
import { getDashboardUrl } from '../redux/selectors/urlSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export const ExitButton = ({
  buttonSize = 'small'
}) => {
  const dashboardUrl = useSelector(getDashboardUrl);
  const personalizationStrategyId = useSelector(getContentModelPersonalizationStrategyId);
  return /*#__PURE__*/_jsx(PersonalizationExitWrapper, {
    strategyId: personalizationStrategyId ? Number(personalizationStrategyId) : undefined,
    buttonProps: {
      size: buttonSize
    },
    children: /*#__PURE__*/_jsx(CEUIExitButton, {
      size: buttonSize,
      dashboardUrl: dashboardUrl
    })
  });
};